// src/plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const opts = {
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.blue.darken1,
        secondary: colors.green.darken1,
        accent: colors.grey.lighten3,
      },
    },
  },
};

export default new Vuetify(opts);
